var render, staticRenderFns
import script from "./Datatable.vue?vue&type=script&lang=tsx&"
export * from "./Datatable.vue?vue&type=script&lang=tsx&"
import style0 from "./Datatable.vue?vue&type=style&index=0&id=3ce6bad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce6bad7",
  null
  
)

export default component.exports